<div *ngIf="CanShow === 1 ">
  <div class="card" *ngIf="CurrentActorPersonalInfoController.ActorCode >0">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10 pink">
          PERSONAL INFORMATION
        </div>
        <div class="col-md-2 float-right" *ngIf="CanEdit === 1 ">
          <a (click)="OpenEditContent()"><span class="badge badge-pink"> <i class="fa fa-edit"></i></span></a>
        </div>
      </div>
    </div>
    <!--<div class="card-header">
      <h5>Personal Information</h5>
      <div class="col-md-4 col-sm-6 col-12 fonticon-container">
        <div class="fonticon-wrap">
          <button class="ft-edit" (click)="OpenEditContent()"> </button>
        </div>

      </div>
    </div>-->
    <div class="card-body">
      <div class="card-block">
        <div class="row">

          <div class="col-12 col-md-6 col-lg-4">
            <ul class="no-list-style">
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.FirstName">
                <span class="text-bold-500 primary"><a><i class="icon-present font-small-3"></i> First Name:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.FirstName}}</span>
              </li>
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.MiddleName">
                <span class="text-bold-500 primary"><a><i class="ft-map-pin font-small-3"></i> Middle Name:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.MiddleName}}</span>
              </li>
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.LastName">
                <span class="text-bold-500 primary"><a><i class="ft-globe font-small-3"></i> Last Name:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.LastName}}</span>
              </li>
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.DisplayName">
               <span class="text-bold-500 primary"><a><i class="ft-mail font-small-3"></i> Display Name:</a></span>
                <a class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.DisplayName}}</a>

              </li>
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.SocialSecurityNumber">
                <span class="text-bold-500 primary"><a><i class="ft-globe font-small-3"></i> Social Security Number:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.SocialSecurityNumber}}</span>
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <ul class="no-list-style">
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.GenderLongValue">
                <span class="text-bold-500 primary"><a><i class="ft-monitor font-small-3"></i> Gender:</a></span>
                <a class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.GenderLongValue}}</a>
              </li>

              <!--<li class="mb-2" *ngIf="CurrentActorPersonalInfoController.BloodGroupLongValue">
                <span class="text-bold-500 primary"><a><i class="ft-mail font-small-3"></i> Blood Group:</a></span>

                <a class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.BloodGroupLongValue}}</a>
              </li>-->
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.NationalityLongValue">
                <span class="text-bold-500 primary"><a><i class="ft-mail font-small-3"></i> Nationality:</a></span>

                <a class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.NationalityLongValue}}</a>
              </li>
              <!--<li class="mb-2" *ngIf="CurrentActorPersonalInfoController.ReligionLongValue">
                <span class="text-bold-500 primary"><a><i class="ft-mail font-small-3"></i> Religion:</a></span>

                <a class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.ReligionLongValue}}</a>
              </li>-->
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.MaritalStatusLongValue">
                <span class="text-bold-500 primary"><a><i class="ft-mail font-small-3"></i> Marital Status:</a></span>

                <a class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.MaritalStatusLongValue}}</a>
              </li>
              <!--<li class="mb-2" *ngIf="CurrentActorPersonalInfoController.IsConvicted">
                <span class="text-bold-500 primary"><a><i class="ft-briefcase font-small-3"></i> Is Convicted:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.IsConvicted}}</span>
              </li>-->

            </ul>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <ul class="no-list-style">
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.DateOfBirth">
                <span class="text-bold-500 primary"><a><i class="ft-user font-small-3"></i> Date Of Birth:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.DateOfBirth}}</span>
              </li>

              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.PlaceOfBirth">
                <span class="text-bold-500 primary"><a><i class="ft-briefcase font-small-3"></i> Place Of Birth:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.PlaceOfBirth}}</span>
              </li>
              <!--<li class="mb-2" *ngIf="CurrentActorPersonalInfoController.LiveIn">
                <span class="text-bold-500 primary"><a><i class="ft-book font-small-3"></i> Live In:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.LiveIn}}</span>
              </li>-->
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.LanguagesSpoken">
                <span class="text-bold-500 primary"><a><i class="ft-book font-small-3"></i> Languages Spoken:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.LanguagesSpoken}}</span>
              </li>
              <li class="mb-2" *ngIf="CurrentActorPersonalInfoController.LanguagesRead">
                <span class="text-bold-500 primary"><a><i class="ft-book font-small-3"></i> Languages Read:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.LanguagesRead}}</span>
              </li>
              <!--<li class="mb-2" *ngIf="CurrentActorPersonalInfoController.HasWorkPermit">
                <span class="text-bold-500 primary"><a><i class="ft-user font-small-3"></i> Has Work Permit:</a></span>
                <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.HasWorkPermit}}</span>
              </li>-->

            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="CanShowRegistryView === 1 && CurrentActorPersonalInfoController">
  <div class="row card-deck">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
      <div class="card" *ngIf="CurrentActorPersonalInfoController.ActorCode >0">
        <div class="card-header wh-header">
          <div class="row">
            <div class="col-md-10 pink">
              PERSONAL INFORMATION
            </div>
           
          </div>
        </div>
    
        <div class="card-body">
          <div class="card-content">
            <div class="card-block">


              <div class="row">
                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.FirstName">
                  <div class="form-group">
                    <label><a> First Name:</a></label>
                    <span>{{CurrentActorPersonalInfoController.FirstName}}</span>
                    </div>
                  </div>
                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.MiddleName">
                  <div class="form-group">
                    <label><a> Middle Name:</a></label>
                    <span>{{CurrentActorPersonalInfoController.MiddleName}}</span>
                    </div>
                  </div>
                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.LastName">
                  <div class="form-group">
                    <label><a>Last Name:</a></label>
                    <span>{{CurrentActorPersonalInfoController.LastName}}</span>
                    </div>
                  </div>
                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.DisplayName">
                  <div class="form-group">
                    <label><a> Display Name:</a></label>
                    <a>{{CurrentActorPersonalInfoController.DisplayName}}</a>
                    </div>
                  </div>
                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.SocialSecurityNumber">
                  <div class="form-group">
                    <label><a> Social Security Number:</a></label>
                    <span>{{CurrentActorPersonalInfoController.SocialSecurityNumber}}</span>
                    </div>
                  </div>
                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.GenderLongValue">
                  <div class="form-group">
                    <label><a> Gender:</a></label>
                    <a>{{CurrentActorPersonalInfoController.GenderLongValue}}</a>
                    </div>
                  </div>


                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.NationalityLongValue">
                  <div class="form-group">
                    <label><a>Nationality:</a></label>

                    <a>{{CurrentActorPersonalInfoController.NationalityLongValue}}</a>
                    </div>
                  </div>

                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.MaritalStatusLongValue">
                  <div class="form-group">
                    <label><a>Marital Status:</a></label>

                    <a>{{CurrentActorPersonalInfoController.MaritalStatusLongValue}}</a>
                    </div>
                  </div>
                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.DateOfBirth">
                  <div class="form-group">
                    <label><a> Date Of Birth:</a></label>
                    <span class="display-block overflow-hidden">{{CurrentActorPersonalInfoController.DateOfBirth}}</span>
                    </div>
                  </div>

                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.PlaceOfBirth">
                  <div class="form-group">
                    <label><a> Place Of Birth:</a></label>
                    <span>{{CurrentActorPersonalInfoController.PlaceOfBirth}}</span>
                    </div>
                  </div>

                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.LanguagesSpoken">
                  <div class="form-group">
                    <label><a> Languages Spoken:</a></label>
                    <span>{{CurrentActorPersonalInfoController.LanguagesSpoken}}</span>
                    </div>
                  </div>
                <div class="col-md-4" *ngIf="CurrentActorPersonalInfoController.LanguagesRead">
                  <div class="form-group">
                    <label><a> Languages Read:</a></label>
                    <span>{{CurrentActorPersonalInfoController.LanguagesRead}}</span>
                    </div>
                  </div>

                </div>




            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>




